import React from 'react';
import { SeoHead } from './components/SeoHead';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { MobileStickyBar } from './components/MobileStickyBar';
import { Hero } from './components/sections/Hero';
import { TrustStrip } from './components/sections/TrustStrip';
import { Services } from './components/sections/Services';
import { Industries } from './components/sections/Industries';
import { Infrastructure } from './components/sections/Infrastructure';
import { AIandISO } from './components/sections/AIandISO';
import { TechnologyEcosystem } from './components/sections/TechnologyEcosystem';
import { Leadership } from './components/sections/Leadership';
import { ClientProofWall } from './components/sections/ClientProofWall';
import { Process } from './components/sections/Process';
import { ITReview } from './components/sections/ITReview';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
export function App() {
  return <div className="min-h-screen w-full bg-white font-body text-ink" data-id="element-0" data-mp="3ij66mgga9xb1">
    <SeoHead data-id="element-1" data-mp="3ml1397n9rmih" /><Header data-id="element-2" data-mp="3mkrc3gqhn9b7" />
    <main data-id="element-3" data-mp="3mk86mzi0yde2">
      <Hero data-id="element-4" data-mp="3mjzrt22ccy08" />
      <TrustStrip data-id="element-5" data-mp="3mjpyb4i388ps" />
      <ClientProofWall data-id="element-6" data-mp="3mj6lu3b7icj5" />
      <Services data-id="element-7" data-mp="3rbrbcsn2y3gv" />
      <Industries data-id="element-8" data-mp="3rdas0kcnegj6" />
      <TechnologyEcosystem data-id="element-9" data-mp="3rcswjpxt86cb" />
      <Infrastructure data-id="element-10" data-mp="3relv0hy9rk98" />
      <AIandISO data-id="element-11" data-mp="6hqtghuuhen" />
      <Leadership data-id="element-12" data-mp="682rygdekbl" />
      <Process data-id="element-13" data-mp="5gez9t0lqvv" />
      <ITReview data-id="element-14" data-mp="56qjqnmbrsa" />
      <FAQ data-id="element-15" data-mp="7stte3h7l4p" />
      <FinalCTA data-id="element-16" data-mp="2zld0z6e9z99y" />
    </main>
    <Footer data-id="element-17" data-mp="2zm4y4lnitf2c" /><MobileStickyBar data-id="element-18" data-mp="2zmepodo7rua5" />
  </div>;
}